import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import {
  type UploadAnalyticsConcurrencyChangeReason,
  type UploadAnalyticsConcurrencyMode,
  type UploadAnalyticsSource,
} from './uploadAnalyticsTypes';
import META from './useTrackUploadConcurrencyChanged.meta';

export type UseTrackUploadConcurrencyChangedParams = {
  active_workers?: number;
  change_reason: UploadAnalyticsConcurrencyChangeReason;
  concurrency_budget_bytes?: number;
  concurrency_mode: UploadAnalyticsConcurrencyMode;
  from_workers: number;
  in_flight_bytes?: number;
  source: UploadAnalyticsSource;
  to_workers: number;
  upload_speed_bytes_per_second?: number;
};

export const useTrackUploadConcurrencyChanged = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadConcurrencyChanged = useCallback(
    (params: UseTrackUploadConcurrencyChangedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackUploadConcurrencyChanged };
};
